"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoFrame = void 0;
const tslib_1 = require("tslib");
const ImageFrame_1 = require("./ImageFrame");
const core_1 = require("@openhps/core");
let VideoFrame = class VideoFrame extends ImageFrame_1.ImageFrame {
};
exports.VideoFrame = VideoFrame;
exports.VideoFrame = VideoFrame = tslib_1.__decorate([
    (0, core_1.SerializableObject)()
], VideoFrame);
//# sourceMappingURL=VideoFrame.js.map